import { render, staticRenderFns } from "./ViewFilter.vue?vue&type=template&id=3dd36dc1"
import script from "./ViewFilter.vue?vue&type=script&lang=js"
export * from "./ViewFilter.vue?vue&type=script&lang=js"
import style0 from "./ViewFilter.vue?vue&type=style&index=0&id=3dd36dc1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd36dc1')) {
      api.createRecord('3dd36dc1', component.options)
    } else {
      api.reload('3dd36dc1', component.options)
    }
    module.hot.accept("./ViewFilter.vue?vue&type=template&id=3dd36dc1", function () {
      api.rerender('3dd36dc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Calendar/ViewFilter.vue"
export default component.exports